import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

// Reusable CTA button. variant: primary | ghost | gold | dark
export const CTAButton = ({
  children,
  to,
  href,
  onClick,
  variant = "primary",
  className = "",
  icon = true,
  ...props
}) => {
  const base =
    "group inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm font-medium tracking-wide transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-red focus-visible:ring-offset-2 focus-visible:ring-offset-brand-cream disabled:opacity-60";
  const variants = {
    primary: "bg-brand-red text-white hover:bg-brand-red-dark",
    dark: "bg-brand-ink text-white hover:bg-black",
    gold: "bg-brand-gold text-brand-ink hover:bg-brand-gold-soft",
    ghost:
      "border border-brand-ink/25 text-brand-ink hover:border-brand-ink hover:bg-brand-ink hover:text-white",
    outlineLight:
      "border border-white/40 text-white hover:bg-white hover:text-brand-ink",
  };
  const cls = `${base} ${variants[variant] || variants.primary} ${className}`;

  const inner = (
    <>
      <span>{children}</span>
      {icon && (
        <ArrowUpRight
          size={16}
          className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
        />
      )}
    </>
  );

  if (to) return <Link to={to} className={cls} {...props}>{inner}</Link>;
  if (href)
    return (
      <a href={href} className={cls} {...props}>
        {inner}
      </a>
    );
  return (
    <button onClick={onClick} className={cls} {...props}>
      {inner}
    </button>
  );
};

export default CTAButton;
